export interface BusinessType {
  id: number
  name: string
}

export interface Customer {
  id: number
  seller_id: number
  seller_name: string
  name: string
  nickname: string | null
  address: string | null
  district: string | null
  phone: string | null
  dni: string | null
  ruc: string | null
  payment_mode: 'cash' | 'credit'
  cycle_days: number
  business_type_id: number | null
  business_type_name: string | null
  business_type_other: string | null
  channel: 'street' | 'wholesale'
  details: string | null
  latitude: number | null
  longitude: number | null
  is_active: boolean
  created_at: string
}

export interface CustomerForm {
  name: string
  nickname: string
  address: string
  district: string
  phone: string
  dni: string
  ruc: string
  payment_mode: 'cash' | 'credit'
  cycle_days: number
  business_type_id: number | null
  business_type_other: string
  channel: 'street' | 'wholesale'
  details: string
  latitude: number | null
  longitude: number | null
}

// A factory (not a constant) so each tab can default new customers to its
// own channel (StreetTab -> 'street', WholesaleTab -> 'wholesale') without
// the caller having to remember to override the field by hand every time.
export function emptyCustomerForm(channel: 'street' | 'wholesale' = 'street'): CustomerForm {
  return {
    name: '',
    nickname: '',
    address: '',
    district: '',
    phone: '',
    dni: '',
    ruc: '',
    payment_mode: 'cash',
    cycle_days: 30,
    business_type_id: null,
    business_type_other: '',
    channel,
    details: '',
    latitude: null,
    longitude: null,
  }
}
